module.exports = __webpack_public_path__ + "img/collection.f2f7584e.svg";